export default __webpack_public_path__ + "static/media/trash-icon.17b1f691.svg";